import { createAction } from '@ngrx/store';

export const declineProtection = createAction(
  '[Additional Services] Decline Protection'
);
export const resetDeclineProtection = createAction(
  '[Additional Services] Reset Decline Protection'
);

export type DeclineProtectionActions =
  | typeof declineProtection
  | typeof resetDeclineProtection;
